// extracted by mini-css-extract-plugin
module.exports = {"buttonArrow":"ButtonArrow_buttonArrow__18Y_A","disabled":"ButtonArrow_disabled__AmSH8","xs":"ButtonArrow_xs__-66TJ"};